// i18n area 'backups' — locale hu-HU (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.hu-HU.meta.json.
import type { enUS } from './backups'

export const huHU: typeof enUS = {
  ckpt: {
    contents: 'Elfogad',
    contentsHint:
      'Mi landolhat itt. A „Checkpointok” a fürt konfigurációja, az „Adatmentések” a virtuális gépek mentései: a két olvasat összeáll, egy cél mindkettőt elfogadhatja.',
    content: { checkpoints: 'Checkpointok', backups: 'Adatmentések' },
    destinationsTitle: 'Backup-célhelyek',
    checkpointsTitle: 'Checkpointok',
    restoreTitle: 'Visszaállítás',
    addDestination: 'Célhely hozzáadása',
    addDestinationTitle: 'Backup-célhely hozzáadása',
    editDestinationTitle: 'Célhely szerkesztése',
    storage: 'Tároló',
    storageHint:
      'Egy dir-jellegű tároló (dir/NFS/CIFS/CephFS) — az artefaktumok közönséges fájlok a platform névtere alatt.',
    schedule: 'Ütemezés',
    scheduleNone: 'Csak kézzel',
    scheduleHourly: 'Óránként',
    scheduleDaily: 'Naponta',
    scheduleWeekly: 'Hetente',
    scheduleHour: 'Óra',
    scheduleWeekday: 'Nap',
    scheduleHint:
      'Az ütemezett checkpointoknál nincs operátor, aki beírná a masterpass-t: a keystore titkai helyőrzőként kerülnek a csomagba.',
    retention: 'Megőrzés',
    retentionHint:
      'Hány ütemezett checkpoint maradjon meg — a sweeper a számon felüli legrégebbieket eltávolítja. A kézi és a visszaállítás előtti checkpointok soha nem kerülnek eltávolításra.',
    paused: 'Szüneteltetve',
    pausedHint:
      'Az operátor blackoutja: amíg a szünet tart, ezen a célhelyen semmi sem ütemeződik és semmi sem kerül megritkításra — az adat-policyk és a checkpointok egyaránt. A folyamatban lévő futásokat soha nem érinti.',
    orphanRuns: '{n} árva futás',
    orphanRunsHint:
      'Olyan policy-k ütemezett futásai, amelyek ezen a célon már nem léteznek: semmilyen retention nem kormányozza őket — soha nem számolják, soha nem gyérítik — és csak kéz törli őket. A tvirt diagnose „backups” lencséje megnevezi az eltávolított policy-kat.',
    rescan: 'Artefaktumok újraadoptálása',
    rescanTitle: '{name} artefaktumainak újraadoptálása',
    rescanHint:
      'Újraépíti a mentéskatalógust (VM/CT/App) a célhelyen lévő artefaktumok manifesztjeiből. A meglévő sorokhoz soha nem nyúl; az ismeretlen szabályzatok mentései árvák maradnak (soha nem kerülnek automatikus törlésre). A bootstrap-visszaállítás utáni lépés.',
    masterpassDrWarning:
      'Katasztrófa-forgatókönyv: a LUKS lemezek CSAK masterpass-szal készült checkpointból térnek vissza. Az ütemezett checkpointok helykitöltőket csomagolnak — készítsen rendszeresen kézi checkpointot masterpass-szal.',
    policy: {
      title: 'Adatmentési policyk',
      hint: 'Nevesített policyk: mely objektumok (kind, címkék, scope-ok), milyen gyakran, mikor indulhat egy futás, és hány másolat maradjon. A besorozás gesztusa az objektum tulajdonosánál marad: a címkéket a saját scope-ján osztja ki.',
      add: 'Policy hozzáadása',
      column: 'Adat-policyk',
      name: 'Név',
      nameHint:
        'A policy címkéje, egyedi a célon belül. A futások a policy stabil id-jét követik: az átnevezés ingyenes; a törlés árvává teszi a futásait (többé nem számolják és nem gyérítik).',
      kindLocked: 'Egy meglévő policy objektumcsaládja nem változtatható: hozz létre új policy-t.',
      kindLabel: 'Objektumok',
      kind: { vm: 'Virtuális gépek', ct: 'Konténerek', app: 'Appok' },
      tags: 'Címkeválasztó',
      tagsHint:
        'Vesszővel elválasztott tag=érték párok, AND kapcsolatban. Az üres címkék és scope-ok semmit sem választanak ki — soha nem „mindent”.',
      scopes: 'Scope-ok',
      scopesHint: 'Scope-útvonalak (részfák), vesszővel elválasztva, egymással OR kapcsolatban.',
      windowStart: 'Ablak ettől',
      windowEnd: 'Ablak eddig',
      windowHint:
        'Végrehajtási ablak (HH:MM, helyi idő; a végénél későbbi kezdet átlép az éjfélen). Csak az INDULÁST szabályozza: a rajta túlnyúló futást soha nem öljük meg.',
      mode: 'Mód',
      modeHint:
        'Az inkrementális a sorozatcsaládon lovagol; a megszakadt sorozat full-lá degradálódik, a naplóban elmondva.',
      modeFull: 'Full',
      modeIncremental: 'Inkrementális',
      requireQuiesce: 'Quiesce megkövetelése (guest agent)',
      paused: 'Policy szüneteltetve',
      retentionNone: 'Mindent megtart',
      retentionCount: 'Darabszám',
      retentionGfs: 'GFS-gyűrűk',
      gfs: { keepLast: 'Utolsó', daily: 'Napi', weekly: 'Heti', monthly: 'Havi', yearly: 'Éves' },
      gfsHint:
        'Minden gyűrűhöz az utolsó N időszak mindegyikének legújabb mentése marad meg. A megtartott mentés életben tartja a teljes láncát — soha nem marad bázis árvákkal.',
      lastRun: 'Utolsó futás',
      neverRan: 'még sosem futott'
    },
    lastCheckpoint: 'Utolsó checkpoint',
    neverRun: 'Még sosem készült',
    createNow: 'Checkpoint készítése',
    createNowTitle: 'Checkpoint készítése — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'A keystore titkos értékeit védi (argon2id → AES-256-GCM, értékenként). Soha nem tárolódik: őrizd meg — nélküle a visszaállítás valódi titkok helyett helyőrzőket ad.',
    masterpassEmptyHint: 'Hagyd üresen, ha a titkok helyett explicit helyőrzőket szeretnél csomagolni.',
    createStarted: 'Checkpoint folyamatban…',
    destinationInUseError: "A(z) '{name}' még checkpointokat tartalmaz — előbb töröld őket.",
    origin: 'Eredet',
    originManual: 'kézi',
    originSchedule: 'ütemezett',
    originPreRestore: 'visszaállítás előtti',
    originPreChange: 'módosítás előtti',
    preChangeRetention: 'Módosítás előtti checkpointok',
    preChangeRetentionHint:
      'Üres = kikapcsolva. Egy nyugalmi időszak utáni első konfigurációs írás itt rögzíti a korábbi állapotot (eredet: módosítás előtti); a legújabbak a megadott számig maradnak meg — saját, metszhető retenció.',
    diffTitle: 'Változások előnézete',
    diffFailed: 'Az előnézet nem sikerült',
    diffRetry: 'Újra',
    diffCounts: '{changed} módosul · {missing} létrejönne · {extra} felesleges · {equal} azonos',
    diffChanged: 'módosul',
    diffMissing: 'létrejönne',
    diffExtra: 'törlődne',
    diffJsonb: 'a jsonb hivatkozások az alkalmazás előtt nem ellenőrizhetők',
    diffSecret: 'lepecsételt mezők, nem összehasonlíthatók',
    diffMore: 'további {n}…',
    diffNeeded: 'Az indítás akkor élesedik, ha az előnézet tükrözi a kijelölést.',
    phase: 'Állapot',
    phaseRunning: 'folyamatban',
    phaseComplete: 'kész',
    phaseError: 'hiba',
    secrets: 'Titkok',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'helyőrzők',
    size: 'Méret',
    created: 'Létrehozva',
    destination: 'Célhely',
    download: '.tvbk letöltése',
    deleteCheckpoint: 'Checkpoint törlése',
    noCheckpoints: 'Még nincs checkpoint — készíts egyet valamelyik célhelyről.',

    // Round #156 (dialog standard): la superficie di lettura completa del
    // record di archivio — righe di dettaglio per i campi mai mostrati in tabella.
    families: 'Családok',
    generation: 'Generáció',
    completedAt: 'Befejezve',
    errorDetail: 'Hiba részletei',
    manifest: 'Manifest',
    restoreHint:
      'Tölts fel egy .tvbk artefaktumot: az explorer megmutatja, mit tartalmaz, aztán kiválaszthatod, mit és hogyan állítasz vissza.',
    uploadFile: '.tvbk fájl feltöltése',
    uploading: 'Feltöltés…',
    uploadFailed: 'Az artefaktum nem nyitható meg',
    explorerTitle: 'A checkpoint tartalma',
    checkpointFrom: 'Checkpoint a(z) {cluster} klaszterről, létrehozva: {when} ({origin}, generáció: {generation})',
    otherCluster:
      'Ez a checkpoint egy MÁSIK klaszteren készült ({cluster}) — a klaszterek közötti visszaállítás egy jövőbeli körben érkezik.',
    encrypted: 'titkosítva',
    objectsCount: '{n} objektum',
    mode: 'Mód',
    modeMerge: 'Merge — egyeztet: upsert a kijelölt sorokra, semmit nem töröl',
    modeOverwrite:
      'Overwrite — a checkpoint győz: a teljesen kijelölt család egészében lecserélődik (a checkpointból hiányzó jelenlegi sorok törlődnek)',
    restoreMasterpassHint:
      'A masterpass, amellyel a checkpoint készült. Nélküle a titkosított titkok explicit helyőrzőkként állnak vissza.',
    checkMasterpass: 'Ellenőrzés',
    masterpassOk: 'A masterpass helyes',
    masterpassWrong: 'Hibás masterpass',
    parachuteDestination: 'Ejtőernyő-célhely',
    parachuteHint:
      'Mielőtt bármelyik sorhoz hozzányúlna, a feladat itt készít egy automatikus, visszaállítás előtti checkpointot.',
    summaryTitle: 'Mi fog történni',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'teljes család',
    summaryObjects: '{n} kijelölt objektum',
    confirmHint:
      'A megerősítéshez írd be a klaszter nevét ({name}) — a visszaállítás átírja a deklarált konfigurációt.',
    confirmField: 'A klaszter neve',
    startRestore: 'Visszaállítás',
    restoreRunning: 'Visszaállítás folyamatban…',
    restoreDone: 'Visszaállítás kész — a reconcilerek az új deklarációra konvergálnak.',
    restoreFailed: 'A visszaállítás nem sikerült',
    discard: 'Elvetés',
    selectionEmpty: 'Jelölj ki legalább egy családot vagy objektumot.'
  },

  backup: {
    intro: {
      title: 'A VM-ek és konténerek adatainak biztonsági mentése',
      subtitle: 'Az építőkockák, amelyeket a külső biztonsági mentési szoftverek használnak',
      whatItIs:
        'A TVirt négy primitívet tesz elérhetővé: quiesced pillanatképek, lemezenkénti változáskövetés, csak olvasható NBD-export és a konfiguráció exportja. Ezeket a Veeam, a Bacula, az Acronis és társaik vezérlik.',
      whatItIsNot:
        'A TVirt nem biztonságimentés-termék: semmit sem ütemez, nem kezel megőrzést, és nem tárol semmilyen archívumot az adataidról. A megőrzés, a katalógusok és a visszaállítási szabályzatok annál a szoftvernél maradnak, amelyet már most is használsz.'
    },
    cbt: {
      title: 'Változáskövetés',
      colVm: 'VM',
      colDisk: 'Lemez',
      colState: 'Állapot',
      colBitmaps: 'Bitmapek',
      colObservedAt: 'Megfigyelve',
      colChangeId: 'Change ID',
      colMechanic: 'Mechanizmus',
      stateActive: 'Aktív',
      stateInactive: 'Kikapcsolva',
      stateInconsistent: 'Inkonzisztens — a következő mentésnek teljesnek kell lennie',
      stateBroken: 'Lánc megszakadt — kapcsolja ki, majd kapcsolja be új láncként',
      stateSnapshots: 'Mindig aktív — delta pillanatképek között',
      stateUnavailable: 'Ezen a lemezen nem elérhető',
      mechanic: {
        'qcow2-bitmap': 'qcow2 bitmap',
        'rbd-snapdiff': 'Ceph pillanatkép-diff',
        'lvm-thin-delta': 'Thin pool delta',
        none: 'Nincs'
      },
      empty:
        'Nincs VM-lemez. A változáskövetés lemezenként olvasható: kapcsolja be qcow2 lemezen, vagy készítsen pillanatképeket rbd/SAN-on.',
      chainBroken: 'Lánc megszakadt',
      chainBrokenText:
        'Megszakította: {reason}: {bitmaps}. Kapcsolja ki a bitmapet (a lánc elveszett, a következő mentés teljes), majd kapcsolja be új láncként.',
      lineages: 'Korszakok',
      epochFrozen: 'befagyasztva a(z) {snapshot} pillanatképben',
      epochLost: 'elveszett ({cause})',
      epochRecording: 'rögzít a fejen',
      milestones: 'Mérföldkövek (pillanatképek)',
      enable: 'Változáskövetés bekapcsolása',
      disable: 'Kikapcsolás',
      reset: 'Visszaállítás',
      changedAreas: 'Módosult területek',
      denied: 'Nincs jogosultsága ezen a VM-en',
      enableTitle: 'Változáskövetés bekapcsolása',
      disableTitle: 'Változáskövetés kikapcsolása',
      resetTitle: 'Bitmap visszaállítása',
      areasTitle: 'Módosult területek',
      bitmapName: 'Bitmap neve',
      bitmapNameHint: 'Saját név: a tvirt- és tvbk- a platformé',
      granularity: 'Granularitás (bájt)',
      granularityHint: 'Kettő hatványa; alapértelmezés 65536',
      bitmap: 'Bitmap',
      disableHint: 'Eltávolítja a bitmapet és a teljes korszaktörténetét: a következő mentésnek teljesnek kell lennie.',
      resetHint: 'Kiüríti a bitmapet — új alap: a visszaállításnál régebbi change ID többé nem állítható össze.',
      areasFrom: 'Pillanatképtől',
      areasTo: 'Pillanatképig',
      areasRun: 'Számítás',
      areasResult: '{count} módosult terület, {bytes}',
      areasEmpty: 'Nincs módosult terület a két pillanatkép között',
      areasZero: 'nullák',
      areasMore: 'az első {shown} látható a(z) {count} közül',
      submit: 'Megerősítés',
      error: 'A változáskövetési művelet sikertelen'
    },
    exports: {
      title: 'Nyitott NBD-exportok',
      colVm: 'VM',
      colDisk: 'Lemez',
      colSnapshot: 'Pillanatkép',
      colBitmap: 'Bitmap',
      colPhase: 'Fázis',
      colNode: 'Csomópont',
      colEndpoint: 'Végpont',
      colExpires: 'Lejár',
      colCreated: 'Megnyitva',
      colError: 'Hiba',
      phase: {
        preparing: 'Előkészítés',
        ready: 'Kész',
        closed: 'Lezárva',
        error: 'Sikertelen'
      },
      expiresIn: '{minutes} perc múlva',
      expired: 'lejárt',
      empty: 'Nincs export. Egy olvasási munkamenet egy lemezt szolgál ki egy pillanatképnél egy NBD-kliensnek; egy írási munkamenet egy leállított VM érintetlen lemezét tölti fel. Mindkettő lejáratkor hal meg.',
      endpointHint: 'TLS a fürt CA-jával; az export neve a jegy — a munkamenettel együtt hal meg',
      closeDenied: 'Nincs jogosultsága exportok lezárására ezen a VM-en',
      open: 'NBD-export megnyitása',
      openTitle: 'NBD-export megnyitása',
      openDisk: 'Lemez',
      openBitmap: 'Bitmap (opcionális)',
      openBitmapHint:
        'Közzéteszi a bitmap ebben a pillanatképben befagyasztott korszakát a módosult extentek meta-contextjeként (csak qcow2 lemezek)',
      openTtl: 'Élettartam (perc)',
      openSubmit: 'Megnyitás',
      openError: 'Az exportot nem sikerült megnyitni',
      colMode: 'Mód',
      mode: {
        read: 'Olvasás',
        write: 'Írás'
      },
      caCertificate: 'A fürt CA-ja',
      caCopy: 'PEM másolása',
      caDownload: 'ca-cert.pem letöltése',
      caHint: 'Írd a PEM-et a ca-cert.pem fájlba egy privát könyvtárban, és csatlakozz az nbds://…?tls-certificates=<könyvtár> (nbdcopy, nbdinfo) vagy --object tls-creds-x509,dir=<könyvtár>,endpoint=client (qemu-img) címmel',
      caAbsent: 'A munkamenet nem hordoz CA-t (nincs PKI)',
      openWrite: 'Írási export megnyitása',
      openWriteTitle: 'Írási export megnyitása',
      openWriteIntro: 'A lemeznek érintetlennek kell lennie: üresen született, sosem írták, nincs pillanatképe; a VM leállítva. A visszaállítás FELTÖLTI a lemezt, nem javítja. Amíg a munkamenet nyitva van, a VM nem indul, nem készít pillanatképet, nem klónozódik, és a lemez nem mozgatható.',
      openWriteSubmit: 'Megnyitás',
      openWriteError: 'Az írási exportot nem sikerült megnyitni',
      openWriteDenied: 'Hiányzik a vm.restore.data ezen a VM-en',
      openWriteStopped: 'Állítsd le a VM-et az írási export megnyitásához',
      fromDescription: 'VM létrehozása leírásból',
      fromDescriptionTitle: 'VM létrehozása leírásból',
      fromDescriptionIntro: 'Az export-vm-meta leírása leállított VM-ként tér vissza a leírt geometria üres lemezeivel — készen az írási exportokra, lemezről lemezre. A bájtok nem itt haladnak át: a restore-disk (CLI) vagy a mentőtermék NBD-kliense viszi őket.',
      fromDescriptionDoc: 'Leírás (JSON)',
      fromDescriptionDocHint: 'Illeszd be az export-vm-meta dokumentumát, vagy válaszd ki a fájlt',
      fromDescriptionFile: 'Fájl kiválasztása…',
      fromDescriptionInvalid: 'A szöveg nem JSON-dokumentum',
      fromDescriptionName: 'Az új VM neve',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'A kiinduló scope-od',
      fromDescriptionStorage: 'Lemezek tárolója',
      fromDescriptionStorageHint: 'Minden lemez itt születik, a tároló alapértelmezett formátumában',
      fromDescriptionMetadataStorage: 'Metaadatok tárolója',
      fromDescriptionSameAsStorage: 'Ugyanaz, mint a lemezeké',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bridge és hálózat nélkül a VM kártyák nélkül születik',
      fromDescriptionNetwork: 'Logikai hálózat (fabric/hálózat)',
      fromDescriptionSubmit: 'Létrehozás',
      fromDescriptionError: 'A VM-et nem sikerült létrehozni',
      fromDescriptionDone: 'VM létrehozva: {name}',
      fromDescriptionOpen: 'VM megnyitása',
      fromDescriptionDenied: 'Hiányzik a vm.create',
      fromDescriptionStillRunning: 'A létrehozás még folyamatban: tovább várunk'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Virtuális gépek adatmentései',
      titleOnVm: 'Adatmentések',
      empty:
        'Nincs mentés. A mentés a lemezeket, az UEFI varstore-t és a vTPM állapotát viszi át egy célra, és túléli a virtuális gépet.',
      colVm: 'VM',
      colCreated: 'Készült',
      colPhase: 'Eredmény',
      colDestination: 'Cél',
      colContains: 'Tartalom',
      colSize: 'Méret',
      colOrigin: 'Eredet',
      colMode: 'Típus',
      retentionChip: 'Megőrzés',
      retentionHint:
        'A cél megőrzési szabálya kérdés nélkül törölheti ezt a mentést: ütemezésből született. A kézi mentéseket soha nem söpri el.',
      policyRemoved: 'Policy eltávolítva: {name}',
      policyRemovedHint:
        'Az ezt a backupot ütemező policy már nem létezik: semmilyen retention nem kormányozza (soha nem gyérítik automatikusan) — töröld kézzel, ha már nincs rá szükség.',
      phase: {
        running: 'Folyamatban',
        complete: 'Kész',
        error: 'Meghiúsult'
      },
      origin: {
        manual: 'Kézi',
        schedule: 'Ütemezett'
      },
      mode: {
        full: 'Teljes',
        incremental: 'Növekményes'
      },
      contains: {
        disks: 'Lemezek',
        varstore: 'UEFI varstore',
        vtpm: 'vTPM állapot',
        snapshots: 'Pillanatképek'
      },
      vmState: {
        stopped: 'VM leállítva',
        running: 'VM fut (meleg)'
      },
      artifactClass: { metadata: 'Metaadat', data: 'Adat', secret: 'Titok' },
      detail: {
        tabOverview: 'Áttekintés',
        tabArtefact: 'Artefaktum',
        id: 'Azonosító',
        scope: 'Hatókör',
        vmState: 'A VM állapota a másoláskor',
        pointInTime: 'Az adatok pillanata',
        completedAt: 'Befejeződött',
        node: 'A másoló csomópont',
        error: 'Hiba',
        path: 'Könyvtár a tárolón',
        checksum: 'a manifest sha256 értéke',
        secretsExposed: 'Érzékeny anyag titkosítatlanul',
        secretsExposedYes: 'Igen — a cél nem titkosít',
        secretsExposedNo: 'Nem',
        baseBackup: 'Alapmentés',
        tabManifest: 'Manifest',
        manifestHint:
          'Az artefaktum nyílt indexe: soronként egy fájl a saját sha256 értékével. A könyvtár TVirt nélkül is ellenőrizhető — elég a qemu-img, a tar és a jq.',
        manifestEmpty: 'A manifest nem sorol fel fájlokat.',
        manifestError: 'A manifest nem olvasható',
        colEntry: 'Fájl',
        colClass: 'Osztály',
        colSha: 'sha256'
      },
      create: {
        action: 'Mentés most',
        title: 'Mentés most',
        submit: 'Mentés indítása',
        destination: 'Cél',
        destinationHint: 'Csak a mentéseket elfogadó célok.',
        noDestinations: 'Egyetlen cél sem fogad mentéseket: hozzon létre egyet a Rendszer → Checkpointok alatt.',
        contentsHint:
          'Minden lemez utazik, továbbá az UEFI varstore és a vTPM állapota. Az utóbbi kettő a lényeg: egy lepecsételt vendégnek újra el kell indulnia.',
        error: 'A mentés nem indult el',
        stillRunning: 'A mentés még fut — a másolás akkor is folytatódik, ha bezárja.',
        vmRunning:
          'A virtuális gép {phase}: a mentéshez nyugalmi VM kell — leállított a hideg másoláshoz, futó a meleghez.'
      },
      restore: {
        action: 'Visszaállítás',
        title: 'Visszaállítás',
        intro:
          'A visszaállítás visszafordíthatatlan. Válassza ki, hová térjenek vissza az adatok: új gépbe, vagy az eredetire.',
        modeNewVm: 'Visszaállítás ÚJ virtuális gépbe',
        modeNewVmHint:
          'Semmihez sem nyúl, ami létezik — ezzel a lehetőséggel ellenőrizhető egy mentés. Új azonosító és frissen vert MAC-címek.',
        modeOver: 'Az eredeti virtuális gép felülírása',
        modeOverHint:
          'Megsemmisíti a célgép jelenlegi adatait, visszaút nélkül. A virtuális gépnek leállítva kell lennie.',
        newName: 'Az új gép neve',
        newNameHint: 'Szabadnak kell lennie a cél hatókörében.',
        storage: 'A lemezek tárolója',
        storageHint: 'Kötelező: a manifest a lemez méretét és formátumát rögzíti, soha nem a tárolót, amelyen feküdt.',
        metadataStorage: 'A varstore és a vTPM tárolója',
        metadataStorageHint: 'Hová kerül az UEFI identitás és a vTPM állapota.',
        sameAsStorage: 'Ugyanaz, mint a lemezeké',
        bridge: 'A gazdagép bridge-e',
        bridgeHint:
          'Minden rögzített hálókártya ezen a bridge-en tér vissza új MAC-címmel. Üresen hagyva a gép kártyák nélkül születik — ez a biztonságosabb alapérték.',
        overwriteTitle: 'Ezt a virtuális gépet készül felülírni',
        overwriteName: 'Név',
        overwriteId: 'Azonosító',
        overwriteDisks: 'Felülírásra kerülő lemezek',
        overwriteNoDisks: 'Nincs lemez.',
        overwriteKeeps:
          'Érintetlen marad az azonosító, a név, a hatókör, a hálókártyák és a MAC-címek: a mentés az ADAT, a konfiguráció a checkpoint.',
        confirmField: 'A gép neve',
        confirmHint: 'Írja be: {name} a megerősítéshez.',
        targetLoading: 'A célgép olvasása…',
        targetRunning: 'A célgép {phase}: a visszaállítás a vendég alatti bájtokat írja felül, ezért leállítva kéri.',
        targetGone: 'Az eredeti gép már nem olvasható: az új gépbe való visszaállítás marad.',
        onlyComplete: 'A mentés {phase}: csak befejezett mentés tud visszaállítani.',
        submitNewVm: 'Visszaállítás az új gépbe',
        submitOver: 'Felülírás',
        error: 'A visszaállítás nem indult el',
        stillRunning: 'A visszaállítás még fut — teljes lemezeket másolni időbe telik.'
      }
    },
    guest: {
      title: {
        ct: 'Konténerek adatmentései',
        app: 'App-ok adatmentései'
      },
      tabTitle: 'Mentések',
      empty: 'Nincs mentés. A mentés a tartós adatokat egy célra másolja, és túléli az objektumát.',
      colSubject: {
        ct: 'Konténer',
        app: 'App'
      },
      colCreated: 'Készült',
      colPhase: 'Kimenetel',
      colDestination: 'Cél',
      colContains: 'Tartalom',
      colSize: 'Méret',
      colOrigin: 'Eredet',
      policyRemoved: 'Policy eltávolítva: {name}',
      policyRemovedHint:
        'Az ezt a backupot ütemező policy már nem létezik: semmilyen retention nem kormányozza (soha nem gyérítik automatikusan) — töröld kézzel, ha már nincs rá szükség.',
      phase: {
        running: 'Folyamatban',
        complete: 'Kész',
        error: 'Sikertelen'
      },
      origin: {
        manual: 'Kézi',
        schedule: 'Ütemezett'
      },
      state: {
        stopped: 'Objektum leállítva',
        running: 'Objektum fut (fagyasztva)'
      },
      contains: {
        rootfs: 'Rootfs-fa',
        config: 'Konfiguráció',
        volumes: 'Tartós kötetek',
        root: 'Tartós root'
      },
      artifactClass: {
        metadata: 'Metaadatok',
        data: 'Adatok',
        secret: 'Titok'
      },
      create: {
        action: 'Mentés most',
        title: 'Új mentés',
        submit: 'Mentés indítása',
        error: 'A mentés nem indult el',
        destination: 'Cél',
        destinationHint: 'Csak az adatmentéseket elfogadó célok.',
        noDestinations: 'Egyetlen cél sem fogad adatmentéseket: adja hozzá egy célhoz az „Adatmentések”-et.',
        hint: {
          ct: 'A teljes rootfs-fa utazik, hűen (numerikus tulajdonosok, xattr-ok, ACL-ek), plusz a deklarált konfiguráció a manifestben. A futó konténert a csomagolás idejére BEFAGYASZTJUK: crash-consistent másolat, deklarálva.',
          app: 'CSAK a tartós kötetek (és a tartós root) utaznak, plusz a konfiguráció a manifestben. Az efemer részek ratifikációval kizártak és a manifest megnevezi őket; a titkosnak deklarált env-értékek nem utaznak.'
        },
        stillRunning: 'A mentés még fut — teljes fák csomagolása időbe telik.'
      },
      detail: {
        tabOverview: 'Áttekintés',
        tabManifest: 'Manifest',
        id: 'Azonosító',
        scope: 'Hatókör',
        state: 'Állapot a másoláskor',
        pointInTime: 'Adatok az időpontban',
        completedAt: 'Lezárva',
        node: 'Másoló csomópont',
        error: 'Hiba',
        path: 'Mappa a tárolón',
        checksum: 'manifest sha256',
        manifestHint:
          'Az artefakt indexe: fájlonként egy bejegyzés a sha256-tal — hash-ek nélkül „a mentés megvan” hit kérdése.',
        manifestError: 'A manifest nem olvasható',
        manifestEmpty: 'Nincs artefakt a manifestben.',
        colEntry: 'Fájl',
        colClass: 'Osztály',
        colSha: 'sha256',
        excluded: 'Ratifikációval kizárva (nem utazik)',
        secretKeys: 'Kihagyott titkos env-kulcsok (#307) — visszaállítás után írja be újra'
      },
      restore: {
        action: 'Visszaállítás',
        title: 'Visszaállítás',
        submit: 'Visszaállítás',
        error: 'A visszaállítás nem indult el',
        stillRunning: 'A visszaállítás még fut — teljes fák kicsomagolása időbe telik.',
        onlyComplete: 'A mentés {phase}: csak kész mentés állíthat vissza.',
        asNew: {
          ct: 'ÚJ konténerbe — semmit sem rombol: a gesztus, amellyel egy mentést ellenőriznek',
          app: 'ÚJ App-ba — semmit sem rombol: a gesztus, amellyel egy mentést ellenőriznek'
        },
        over: {
          ct: 'A forráskonténer FÖLÉ — a teljes rootfs-fa lecserélődik',
          app: 'A forrás-App FÖLÉ — minden tartós kötet tartalma lecserélődik'
        },
        name: 'Az új objektum neve',
        storage: 'Tároló',
        storageHint: 'Ahol a visszaállított adatok landolnak — a manifest sosem jegyzi fel az elveszett poolt.',
        storageDeclared: 'A manifestben deklarált tárolók',
        bridge: 'Gazda-bridge',
        bridgeHint:
          'Minden feljegyzett kártya ezen a bridge-en tér vissza friss MAC-kel. Üres = csatlakozás nélkül születik, a legbiztonságosabb alapértelmezés.',
        node: 'Csomópont',
        nodeHint: 'A tag, amelyen az App újjászületik: a csomópont klaszteridentitás, és sosem a manifestből jön.',
        secretKeysWarning:
          'A titkosnak deklarált env-értékek nem utaznak a mentésben: az újjászületett példány újra kéri őket (a task naplója megnevezi a kulcsokat).',
        overInventory: 'Mindjárt felülírja ezt az objektumot',
        confirmType: 'A megerősítéshez írja be: {name}',
        targetGone: 'A forrásobjektum már nem olvasható: marad a visszaállítás újként.',
        targetLoading: 'A célobjektum olvasása…',
        targetRunning: 'A célobjektum fut: a visszaállítás a vendég alatti bájtokat cseréli le, ezért leállítva kéri.'
      }
    }
  }
}
